/* Scroll-entrance reveals — arms [data-reveal] elements with the DS rise
   (styles in base.css: .rv / .rv-group / .is-in).

   Safety posture, in order of importance:
   · Content is never hidden without a working path back. Elements already in
     the first viewport are skipped entirely — the arrival choreography there
     is CSS-only — so JS failure can only cost motion, never content.
   · prefers-reduced-motion skips arming altogether: below-fold content is
     simply present, which is the intentional reduced path (the global guard
     in base.css would zero the durations anyway; this avoids even the
     appear-on-scroll pop).
   · A watchdog covers the pathological embedder whose IntersectionObserver
     never delivers (seen in headless capture tools): if the first scroll
     produces no callback within 800ms, everything dissolves to visible. */
(function () {
  function boot() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    if (!els.length) return;

    var fired = false;
    var io = new IntersectionObserver(function (entries) {
      fired = true;
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    var armed = [];
    els.forEach(function (el) {
      /* 0.92: an element peeking into the bottom 8% of the first viewport is
         "in view" for this purpose — hiding it would flash content away. */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
      el.classList.add(el.getAttribute('data-reveal') === 'group' ? 'rv-group' : 'rv');
      armed.push(el);
      io.observe(el);
    });
    if (!armed.length) return;

    window.addEventListener('scroll', function onFirstScroll() {
      window.removeEventListener('scroll', onFirstScroll);
      setTimeout(function () {
        if (fired) return;
        armed.forEach(function (el) { el.classList.add('is-in'); });
        io.disconnect();
      }, 800);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
